import z from 'zod';
import { createAnalyticsSchema } from './../factory/createAnalyticsSchema';
export var TestDataSchema = createAnalyticsSchema({
    steps: z.array(z.object({
        challenge: z.array(z.number()),
        response: z.array(z.number()),
        snr: z.number(),
        passed: z.boolean(),
        timestamp: z.number(),
    })),
    result: z.object({
        score: z.number(),
        category: z.string(),
        pass: z.boolean(),
        averageSnr: z.number(),
        timestamp: z.number(),
    }),
});
